import { useTranslation } from 'next-i18next'
import React from 'react'

import Layouts from '@/layouts/Layouts'

import Banner from './Banner'
import JdihContent from './JdihContent'

const Jdih = () => {
  const { t } = useTranslation()
  return (
    <Layouts
      title={String(t('jdih:title'))}
      description={String(t('jdih:description'))}
    >
      <div className='min-h-screen w-full bg-white pt-14 lg:pt-18'>
        <Banner />

        <JdihContent />
      </div>
    </Layouts>
  )
}

export default Jdih
